<template>
    <div class="breadcrumbs px-mob py-6 bg-color">
        <ul class="pa-0 ma-0 d-flex align-center justify-center">
            <li>{{ itemsOrder.plan.title }}</li>
            <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z"
                        fill="#201747" />
                </svg></li>
            <li>Customise {{ ( allergiesCount > 0 ) ? "( " + allergiesCount + " )" : "(0)" }} </li>
            <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z"
                fill="#201747" />
            </svg></li>
            <li><strong>Protein</strong></li>
        </ul>
    </div>
    <div class="wrap-plan flex-column px-md-6 ma-md-6 my-6 d-flex justify-center px-mob step-protein">
        <div class="mb-4">
            <h1>What is your protein perference?</h1>
            <p>Select what form of protein you would like included</p>
        </div>
        <div class="d-flex flex-row justify-center flex-wrap">
            <div class="plan-item ma-1 ma-md-2 py-5" v-for="(protein, i) in proteinsType" :key="i"
                @click="setClassActive(i)" :class="[protein.isActive ? 'active' : '']">
                <div>
                    <h2 class="text-center">{{ protein.title }}</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-center my-6 px-mob">
        <button class="btn-main-app" @click="nextPage" :disabled="btnDisabled">Proceed to plan days</button>
    </div>

</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'step-3',
    data() {
        return {
            btnDisabled: true,          
        }
    },
    computed: {
        proteinsType() {
            return this.$store.getters.proteinsType;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        itemsOrder() {            
            return this.$store.getters.itemsOrder;
        },

        allergiesCount() {
            const allergies = this.$store.getters.getAllergies || [];
            return allergies.filter(allergie => allergie.isActive).length;

        },
        setNextPage() {
            return this.$store.getters.setNextPage;
        },
    },
    methods: {
        nextPage() {

            if(this.btnDisabled == false) {                
                this.wizardMenu[2].isActive= this.wizardMenu[2].lastItem = false;
                this.wizardMenu[3].isActive = this.wizardMenu[3].lastItem = true;

                if (!this.setNextPage.includes('protein')) {
                    this.setNextPage.push('protein')
                    this.$store.commit('setNextPage', this.setNextPage);
                }
            }

        },
        setClassActive(i) {

            let countActive = 0;
            this.proteinsType.forEach((protein, index) => {
                protein.isActive = false;
                if (index === i) {

                    protein.isActive = !protein.isActive;
                    this.itemsOrder.protein = protein;
                    this.$store.commit('setItemsOrder', this.itemsOrder);

                    Cookies.set('protein', protein.slug, { expires: 3600 });

                }
                if (protein.isActive == true) {
                    countActive++;
                }
            });

            if (countActive > 0) {
                this.btnDisabled = false;
            }
        },
    },
    async beforeMount() {

        if ( Cookies.get('protein') ) {
            this.proteinsType.forEach((protein) => {
                if ( protein.slug === Cookies.get('protein') ) {                     
                    this.itemsOrder.protein = protein;
                    this.$store.commit('setItemsOrder', this.itemsOrder);
                    protein.isActive = true;
                    this.btnDisabled = false;
                    if ( ! this.setNextPage.includes('protein') ) {
                        this.setNextPage.push('protein')
                        this.$store.commit('setNextPage', this.setNextPage);
                        this.nextPage();
                    }

                }

            });
        }

    }
}
</script>

<style scoped  lang="stylus">
.wrap-plan {
    p {
        text-align: center;
    }
    & > div {
        max-width: 600px;
        margin: auto;
    }
}
.plan-item
    min-width: 106px;
    width: 45%;
    max-width: 45%;    

    @media screen and (max-width: 400px) {
        min-width: 100%;
        width: 100%;
        max-width: 100%;
    }
    h2 {
        @media screen and (max-width: 767px) {
            font-size: 14px!important;
            line-height: 1.3;
        }
    }
    &.width-add {        
        max-width: 225px;
    }
    &:last-child 
        @media screen and (max-width: 767px)
            margin-bottom: 4px!important;

h1
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 767px) {
        max-width: 350px;

    }
.breadcrumbs
    ul 
        list-style: none;

.bg-color {
  background: #F1F3F9;
}
</style>